import signedFetch from '../apiCalls/util/signedFetch.js';

export const getCheckUserEmailUrl = (orgId, email) =>
  // @ts-ignore
  `${__API_BASE__}/org/${orgId}/user/check-email?emailAddress=${encodeURIComponent(email.trim())}`;

export default function* checkUserEmail(orgId, email) {
  return yield signedFetch('checkUserEmail', getCheckUserEmailUrl(orgId, email), 'GET');
}
